import { Nullable } from '@/core/utils/CustomTypes'
import PageInfo from '@/services/core/PageInfo'
import SerializableObject from '@/services/core/SerializableObject'
import Order from '../Order'

export default class OrderResponseData extends SerializableObject {
  OrderList: Order[] = []
  PageInfo: Nullable<PageInfo>
}
